import { useQuery } from 'react-query';

import { PaymentInfo } from '../../../types/PaymentInfo';
import Api from '../../api/api';

export const getPaymentInfo = async (id: string): Promise<PaymentInfo> => {
  const [response, bodyOrError] = await Api.get(`users/${id}/payment-info`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetPaymentInfo = (userId?: string) =>
  useQuery({
    queryKey: ['getPaymentInfo', userId],
    queryFn: () => getPaymentInfo(userId!),
    enabled: !!userId && userId.length > 0,
    retry: false,
  });
